import { merkeWertModus, wertModusAus } from "@/lib/wert-modus";
import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router";
import {
  alsSearch,
  ausSearch,
  OHNE_LEERE_EINZELWERTE,
  type SucheFilter,
} from "@/lib/suche-filter";
import { ControllingSeite } from "@/components/ControllingSeite";

/*
 * `/controlling`. Wie bei `index.tsx` bleibt die Route-Datei dünn: die Seite
 * liegt in `src/components/ControllingSeite.tsx` und ist dadurch ohne Router
 * und ohne generierten Routenbaum testbar.
 *
 * Kein `loader`, kein `beforeLoad`: die Daten holt der Query-Hook der
 * Komponente. Damit gehören Lade-, Fehler- und Zugangszustand derselben
 * Stelle, die sie auch anzeigt — und ein 401 landet nicht als Router-Fehler
 * neben der Seite, sondern als Aussage darin.
 */
export const Route = createFileRoute("/controlling")({
  validateSearch: (
    roh: Record<string, unknown> & SearchSchemaInput,
  ): SucheFilter => ausSearch(roh),
  search: { middlewares: [OHNE_LEERE_EINZELWERTE] },
  component: ControllingRoute,
});

function ControllingRoute() {
  const filter = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ControllingSeite
      wertModus={wertModusAus(filter.bw, document.cookie)}
      aufWertModus={(modus) => {
        const bw = modus === "aktuell" ? "aktuell" : "stichtag";
        merkeWertModus(bw);
        void navigate({
          search: alsSearch({ ...filter, bw }),
          replace: true,
          resetScroll: false,
        });
      }}
    />
  );
}
